export const independentLivingAmountNotUsedNotice = {
  title: 'Independent living amount not used',
  description:
    "The independent living amount shown below is not used. Depending on the policy's calculation rules, the projection uses the home-care benefit or pays $0 for independent living care. Room and board remains out of pocket.",
} as const;
